export const GET_CONTACT_DATA="GET_CONTACT_DATA"
export const ADD_CONTACT="ADD_CONTACT"
export const UPDATE_CONTACT="UPDATE_CONTACT"
export const DELETE_CONTACT="DELETE_CONTACT"

